import { SubModuleEnum } from '@/common/appConstants';

export const ClientServicesRoutes = {
  path: 'client-services',
  name: 'Client Services',
  component: () => import('@/views/client-services/ClientServicesView.vue'),
  meta: { requiresAuth: true },
  children: [
    { path: '', redirect: '/client-services/approve-reports' },
    {
      path: 'approve-reports',
      name: 'Approve Reports',
      component: () => import('@/views/client-services/components/ApproveReports.vue'),
      meta: { modulePermission: SubModuleEnum.ApproveReports, title: 'Approve Reports' },
    },
  ],
};
